/**
 * 영상 자막 스타일 카탈로그 (BOOTH-85).
 * 10종 고정 카탈로그 — 운영자는 테마·부스 단위로 스타일을 고르기만 한다.
 * 키오스크가 이 정의를 읽어 캔버스 자막 PNG 를 그리고, 서버 ffmpeg 는 등장 연출(`entrance`)만 담당한다.
 */
/** 기본 자막 스타일 ID */
export const DEFAULT_CAPTION_STYLE_ID = "cinema";
/** 모든 자막 스타일 ID (카탈로그 순서) */
export const CAPTION_STYLE_IDS = [
    "cinema",
    "handwritten",
    "minimal",
    "poster",
    "neon",
    "sticker",
    "brush",
    "gilt",
    "sea",
    "postit",
];
/** 자막 스타일 카탈로그 10종 (스펙 §3) */
export const CAPTION_STYLES = [
    {
        id: "cinema",
        name: "시네마",
        nameEn: "Cinema",
        nameJa: "シネマ",
        nameZh: "电影",
        description: "하단 그늘 + 명조 300 — 한복·웨딩·궁중 기본",
        font: {
            ko: '"Cormorant Garamond", "Nanum Myeongjo", serif',
            en: '"Cormorant Garamond", "Nanum Myeongjo", serif',
            ja: '"Noto Serif JP", serif',
            zh: '"Noto Serif SC", serif',
            weight: 300,
        },
        sizeScale: 1.0,
        color: "#F6F3ED",
        background: "shade",
        align: "center",
        rotateDeg: 0,
        effect: "shadow",
        decoration: "none",
        entrance: "fade",
    },
    {
        id: "handwritten",
        name: "손글씨 메모",
        nameEn: "Handwritten",
        nameJa: "手書きメモ",
        nameZh: "手写便条",
        description: "흰 종이 태그 + 손글씨체 — 제주·감성 테마",
        font: {
            ko: '"Nanum Pen Script", cursive',
            en: '"Nanum Pen Script", cursive',
            ja: '"Yomogi", cursive',
            zh: '"Ma Shan Zheng", cursive',
            weight: 400,
        },
        sizeScale: 1.15,
        color: "#171411",
        background: "tag",
        backgroundColor: "#FFFFFF",
        align: "left",
        rotateDeg: -2,
        effect: "shadow",
        decoration: "none",
        entrance: "fade",
    },
    {
        id: "minimal",
        name: "미니멀 캡션",
        nameEn: "Minimal",
        nameJa: "ミニマル",
        nameZh: "简约",
        description: "고딕 300 작게 + 위 헤어라인 — 밝은 배경·잡지 톤",
        font: {
            ko: '"Noto Sans KR", sans-serif',
            en: '"Noto Sans KR", sans-serif',
            ja: '"Noto Sans JP", sans-serif',
            zh: '"Noto Sans SC", sans-serif',
            weight: 300,
        },
        sizeScale: 0.6,
        color: "#F6F3ED",
        background: "none",
        align: "left",
        rotateDeg: 0,
        effect: "shadow",
        decoration: "hairline-top",
        letterSpacingEm: 0.14,
        entrance: "fade",
    },
    {
        id: "poster",
        name: "포스터 타이틀",
        nameEn: "Poster",
        nameJa: "ポスター",
        nameZh: "海报",
        description: "금빛 굵은 명조 + 위아래 장식선 — 사극·궁중",
        font: {
            ko: '"Nanum Myeongjo", serif',
            en: '"Nanum Myeongjo", serif',
            ja: '"Noto Serif JP", serif',
            zh: '"Noto Serif SC", serif',
            weight: 700,
        },
        sizeScale: 1.3,
        color: "#E8C979",
        background: "shade",
        align: "center",
        rotateDeg: 0,
        effect: "shadow",
        decoration: "rules",
        entrance: "rise",
    },
    {
        id: "neon",
        name: "네온",
        nameEn: "Neon",
        nameJa: "ネオン",
        nameZh: "霓虹",
        description: "핑크 글로우 + 고딕 700 — 사이버 서울·K-pop",
        font: {
            ko: '"Noto Sans KR", sans-serif',
            en: '"Noto Sans KR", sans-serif',
            ja: '"Noto Sans JP", sans-serif',
            zh: '"Noto Sans SC", sans-serif',
            weight: 700,
        },
        sizeScale: 1.1,
        color: "#FFF1FA",
        background: "none",
        align: "center",
        rotateDeg: 0,
        effect: "glow",
        glowColor: "#FF3DAE",
        decoration: "none",
        entrance: "fade",
    },
    {
        id: "sticker",
        name: "스티커",
        nameEn: "Sticker",
        nameJa: "ステッカー",
        nameZh: "贴纸",
        description: "흰 알약 배지 + 오른쪽 정렬 + 살짝 기울임 — K-pop·경쾌한 테마",
        font: {
            ko: '"Noto Sans KR", sans-serif',
            en: '"Noto Sans KR", sans-serif',
            ja: '"Noto Sans JP", sans-serif',
            zh: '"Noto Sans SC", sans-serif',
            weight: 700,
        },
        sizeScale: 0.95,
        color: "#171411",
        background: "pill",
        backgroundColor: "#FFFFFF",
        align: "right",
        rotateDeg: 3,
        effect: "none",
        decoration: "none",
        entrance: "rise",
    },
    {
        id: "brush",
        name: "수묵 붓글씨",
        nameEn: "Ink Brush",
        nameJa: "墨筆",
        nameZh: "水墨书法",
        description: "붓글씨 + 주홍 낙관, 왼쪽에서 번지듯 등장 — 한복·한국 미학",
        font: {
            ko: '"East Sea Dokdo", "Nanum Pen Script", cursive',
            en: '"East Sea Dokdo", "Nanum Pen Script", cursive',
            ja: '"Yuji Syuku", serif',
            zh: '"Zhi Mang Xing", cursive',
            weight: 400,
        },
        sizeScale: 1.2,
        color: "#F6F3ED",
        background: "shade",
        align: "left",
        rotateDeg: -1.5,
        effect: "shadow",
        decoration: "seal",
        decorationColor: "#C8102E",
        entrance: "wipe",
    },
    {
        id: "gilt",
        name: "금박 궁체",
        nameEn: "Gilt",
        nameJa: "金箔",
        nameZh: "金箔",
        description: "금빛 그라데이션 명조 + ✦ 장식 — 왕과 왕비·전통 혼례",
        font: {
            ko: '"Song Myung", "Nanum Myeongjo", serif',
            en: '"Cinzel", "Song Myung", serif',
            ja: '"Shippori Mincho", "Noto Serif JP", serif',
            zh: '"ZCOOL XiaoWei", "Noto Serif SC", serif',
            weight: 400,
        },
        sizeScale: 1.1,
        color: "#F4E2A1",
        fill: { kind: "gradient", colors: ["#F4E2A1", "#C9A44A", "#F4E2A1"], direction: "horizontal" },
        letterSpacingEm: 0.08,
        background: "shade",
        align: "center",
        rotateDeg: 0,
        effect: "shadow",
        decoration: "ornaments",
        entrance: "fade",
    },
    {
        id: "sea",
        name: "제주 바다",
        nameEn: "Jeju Sea",
        nameJa: "済州の海",
        nameZh: "济州海",
        description: "하늘→바다빛 그라데이션 고딕 + 흰 글로우, 위에서 내려앉는 등장 — 제주 환경·제주 사계",
        font: {
            ko: '"Gowun Dodum", "Noto Sans KR", sans-serif',
            en: '"Gowun Dodum", "Noto Sans KR", sans-serif',
            ja: '"Zen Maru Gothic", "Noto Sans JP", sans-serif',
            zh: '"Noto Sans SC", sans-serif',
            weight: 400,
        },
        sizeScale: 1.0,
        color: "#4FC3F7",
        fill: { kind: "gradient", colors: ["#DFF6FF", "#4FC3F7", "#0E7C9A"], direction: "vertical" },
        background: "none",
        align: "center",
        rotateDeg: 0,
        effect: "glow",
        glowColor: "#FFFFFF",
        decoration: "none",
        entrance: "drop",
    },
    {
        id: "postit",
        name: "포스트잇",
        nameEn: "Post-it",
        nameJa: "ふせん",
        nameZh: "便利贴",
        description: "노란 메모지 + 마스킹 테이프 + 손글씨 — 제주 사계·한국 미학·K-POP",
        font: {
            ko: '"Gamja Flower", "Nanum Pen Script", cursive',
            en: '"Gamja Flower", "Nanum Pen Script", cursive',
            ja: '"Yomogi", cursive',
            zh: '"Ma Shan Zheng", cursive',
            weight: 400,
        },
        sizeScale: 1.05,
        color: "#3B3024",
        background: "note",
        backgroundColor: "#FFF3A3",
        align: "left",
        rotateDeg: -2,
        effect: "none",
        decoration: "none",
        entrance: "rise",
    },
];
/** 주어진 id 가 유효한 `CaptionStyleId` 인지 확인 */
export function isCaptionStyleId(x) {
    return typeof x === "string" && CAPTION_STYLE_IDS.includes(x);
}
/** id 로 스타일 조회 — 모르는 id·없음·빈 문자열은 `cinema` 를 돌려준다 */
export function captionStyleById(id) {
    if (id) {
        const found = CAPTION_STYLES.find((s) => s.id === id);
        if (found)
            return found;
    }
    return CAPTION_STYLES[0]; // cinema
}
/**
 * 테마 → 부스 → 기본(`cinema`) 순으로 자막 스타일 ID 를 해석한다.
 * 빈 문자열이나 존재하지 않는 id 는 미지정으로 간주하고 다음 단계로 넘어간다.
 */
export function resolveCaptionStyleId(theme, booth) {
    const candidates = [theme?.captionStyleId, booth?.captionStyleId];
    for (const id of candidates) {
        if (id && isCaptionStyleId(id))
            return id;
    }
    return DEFAULT_CAPTION_STYLE_ID;
}
/**
 * 캔버스 `ctx.font` 에 쓸 폰트 문자열 — `"${weight} ${px}px ${stack}"`.
 * @param style 자막 스타일
 * @param language 현재 언어
 * @param px 글자 크기(px)
 */
export function captionStyleFont(style, language, px) {
    const stack = style.font[language] ?? style.font.ko;
    return `${style.font.weight} ${px}px ${stack}`;
}
//# sourceMappingURL=caption-style.js.map